import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-articlelist',
	templateUrl: './articlelist.component.html',
	styleUrls: ['./articlelist.component.scss']
})
export class ArticleListComponent implements OnInit {
	@Input() title: string;
	@Input() list: Array<object>;
	@Input() fa_icon = 'fa-newspaper-o';
	@Input() height = 1;
	constructor() {}
	ngOnInit() {}

	timeSince(date: Date): string;
	timeSince(date: string): string;
	timeSince(date): string {
		// coerce string, etc into ms timestamp
		let d: number;
		if (typeof date === 'string') {
			d = Date.parse(date);
		} else if (typeof date === 'object') {
			d = date.getTime();
		}
		const c: number = new Date().getTime();
		const delta: number = c - d;
		const msInSecond = 1000;
		const msInMinute = msInSecond * 60;
		const msInHour = msInMinute * 60;
		const msInDay = msInHour * 24;
		const msInYear = msInDay * 365;
		// < minute
		if (delta < msInMinute) {
			return `${Math.floor(delta / msInSecond)} second(s) ago`;
		} else if (delta < msInHour) {
			return `${Math.floor(delta / msInMinute)} minute(s) ago`;
		} else if (delta < msInDay) {
			return `${Math.floor(delta / msInHour)} hour(s) ago`;
		} else if (delta < msInYear) {
			return `${Math.floor(delta / msInDay)} day(s) ago`;
		} else {
			return `${Math.floor(delta / msInYear)} year(s) ago`;
		}
	}
}
